import { Controller } from "stimulus"

// Przyciski Google Pay / Apple Pay dla sklepow z Tpayem. Klik = skrot do
// istniejacego flow: zaznacza typ platnosci Tpay, ustawia grupe walletowa
// i submituje koszyk - klient laduje na stronie platnosci Tpaya.
// Gating urzadzenia: Apple Pay tylko tam, gdzie dziala (ApplePaySession),
// Google Pay na pozostalych - nikt nie widzi przycisku, ktorym nie zaplaci.
export default class extends Controller {
  static targets = ["button"]
  static values = { busyLabel: String }

  connect() {
    const applePayCapable = typeof window.ApplePaySession !== "undefined"
    this.buttonTargets.forEach((button) => {
      const name = button.dataset.walletName
      if (name === "Apple Pay" && !applePayCapable) button.remove()
      if (name === "Google Pay" && applePayCapable) button.remove()
    })
    if (this.buttonTargets.length === 0) {
      this.element.remove()
      return
    }

    // Klik zmienia typ platnosci, a odswiezenie koszyka podmienia ten fragment
    // strony, zanim zamowienie sie zlozy - nowe przyciski przejmuja wiec stan
    // "w toku" z formularza.
    if (this.form?.dataset.walletSubmitting) this.setBusy(true)

    // Powrot "wstecz" z bfcache przywraca strone z zablokowanymi przyciskami.
    this.onPageShow = (event) => {
      if (!event.persisted || !this.form) return
      delete this.form.dataset.walletSubmitting
      this.setBusy(false)
    }
    window.addEventListener("pageshow", this.onPageShow)
  }

  disconnect() {
    if (this.onPageShow) window.removeEventListener("pageshow", this.onPageShow)
  }

  get form() {
    return this.element.closest("form")
  }

  pay(event) {
    const button = event.currentTarget
    const form = this.form
    if (!form || form.dataset.walletSubmitting) return

    const radio = form.querySelector(`[name='order[payment_type_id]'][value='${button.dataset.paymentTypeId}']`)
    if (radio) {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
    }

    // Select grup (lista bankow) nie zawiera grup walletowych - przypisanie
    // mu wartosci spoza listy konczy sie pustym parametrem i odmowa Tpaya
    // (ERR53 channel/group). Wallet jedzie wiec zawsze wlasnym ukrytym polem,
    // a select wylaczamy, zeby nie nadpisal grupy pustka.
    const groupSelect = form.querySelector("select[name='order[tpay_payment_group]']")
    if (groupSelect) groupSelect.disabled = true

    let groupField = form.querySelector("input[name='order[tpay_payment_group]']")
    if (!groupField) {
      groupField = document.createElement("input")
      groupField.type = "hidden"
      groupField.name = "order[tpay_payment_group]"
      form.appendChild(groupField)
    }
    groupField.value = button.dataset.groupId

    // Zlozenie zamowienia trwa okolo sekundy. Drugi klik w tym czasie
    // przerywal w przegladarce pierwsza wysylke i pokazywal klientowi strone
    // juz zlozonego zamowienia zamiast przekierowania do Tpaya.
    let submitted = false
    const trackSubmit = (submitEvent) => {
      submitted = submitEvent.target === form && !submitEvent.defaultPrevented
    }
    window.addEventListener("submit", trackSubmit)
    form.requestSubmit()
    window.removeEventListener("submit", trackSubmit)

    if (submitted) {
      form.dataset.walletSubmitting = "1"
      this.setBusy(true)
    }

    // Dane formularza sa serializowane synchronicznie w srodku requestSubmit,
    // wiec przywrocenie stanu tutaj nie zmienia wysylki. Bez tego powrot ze
    // strony Tpaya (bfcache) wskrzeszal formularz z wylaczonym selectem
    // i ukryta grupa walletu - wybor banku po powrocie z Google Pay
    // wysylalby klienta znow do Google Pay.
    if (groupSelect) groupSelect.disabled = false
    groupField.remove()
  }

  setBusy(busy) {
    this.buttonTargets.forEach((button) => {
      if (busy && button.dataset.idleHtml === undefined) {
        button.dataset.idleHtml = button.innerHTML
        if (this.hasBusyLabelValue) button.textContent = this.busyLabelValue
      } else if (!busy && button.dataset.idleHtml !== undefined) {
        button.innerHTML = button.dataset.idleHtml
        delete button.dataset.idleHtml
      }
      button.disabled = busy
    })
  }
}
